import { render, staticRenderFns } from "./ConversationNewHeaderMobile.vue?vue&type=template&id=1c433a42&"
import script from "./ConversationNewHeaderMobile.vue?vue&type=script&lang=js&"
export * from "./ConversationNewHeaderMobile.vue?vue&type=script&lang=js&"
import style0 from "./ConversationNewHeaderMobile.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports